// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3j9O2","header":"PatientQuestionnaire_header__25_rA","info":"PatientQuestionnaire_info__3jn4q"};